let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6FUNd")).then(() => parcelRequire('jQjGM'));